import { UserType, StakeholderType } from '../helpers/EnumsInternal';


function GetUserLoginRedirectLink(changePwdPrompt: boolean, userType: UserType, stakeholderType: StakeholderType) {
    const pwdPrompt = changePwdPrompt ? '/pwd' : '';

    if (userType === UserType.Stakeholder) {
        switch (stakeholderType) {
            case StakeholderType.Advertiser:
                return '/advertiser' + pwdPrompt;
            case StakeholderType.Supplier:
                return '/supplier' + pwdPrompt;
            case StakeholderType.Processor:
                return '/processor' + pwdPrompt;
            default:
                return '/';
        }

    } else if (userType < UserType.Stakeholder) {
        return '/admin' + pwdPrompt;

    } else {
        return '/';
    }
}

export default GetUserLoginRedirectLink